// extracted by mini-css-extract-plugin
export default {"container":"SandboxInfoBar_container__J-krL"};